import {Storage} from './service';

export const storage = new Storage();
